// utils/analytics.js

// Check if gtag is available
export const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

// Safe gtag function
export const safeGtag = (...args) => {
  if (isGtagAvailable()) {
    window.gtag(...args);
    console.log('📊 GA Event Sent:', args);
    return true;
  }
  console.log('📊 GA Not Available (would send):', args);
  return false;
};

export const initializeAnalytics = () => {
  const consent = localStorage.getItem('giveTechCookieConsent');
  console.log('🔍 Initializing analytics with consent:', consent);
  
  if (consent === 'accepted') {
    // User accepted cookies - enable full tracking
    safeGtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
    
    // Send a test event to verify tracking works
    safeGtag('event', 'cookie_consent_accepted', {
      'event_category': 'consent',
      'event_label': 'user_accepted_cookies'
    });
    
    console.log('✅ Google Analytics: Full tracking enabled');
    
  } else if (consent === 'rejected') {
    // User rejected cookies - ensure tracking is disabled
    safeGtag('consent', 'update', {
      'analytics_storage': 'denied'
    });
    
    console.log('❌ Google Analytics: Tracking disabled');
  }
  
  // If no consent yet, GA remains in default denied state
};

export const trackPageView = (pageTitle, pageLocation) => {
  const consent = localStorage.getItem('giveTechCookieConsent');
  
  if (consent === 'accepted' && isGtagAvailable()) {
    window.gtag('config', 'G-MEZ6X7GNME', {
      page_title: pageTitle,
      page_location: pageLocation
    });
  }
};